import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css'; // Import theme

const toast = useToast();

const showToast = (message, type = 'info', options = {}) => {
  toast[type](message, {
    position: 'top-right', // Global Position
    duration: 5000, // Auto-close after 5 seconds
    dismissible: true, // Show Close Button
    pauseOnHover: true, // Pause when hovered
    queue: false, // Allow multiple toasts
    // className: 'custom-toast-width',
    // ...options, // Allow custom options
    onClick: () => {
      if (options.redirectUrl && options.router) {
        options.router.push(options.redirectUrl);
      } else if (options.redirectUrl) {
        // fallback to full reload
        window.location.href = options.redirectUrl;
      }
    }
  });
};

export default showToast;